// ABOUTME: The return figures panel: what a period got back, beside those returns over time.
// ABOUTME: byState swaps the cards for where the returns stand, which is what a relation follows.

import { useTranslation } from "react-i18next";
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import FunctionsIcon from '@mui/icons-material/Functions';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';

import ShTotalsPanel from "../../theme/cards/ShTotalsPanel";
import { useGetReturnDashboardChartQuery, useGetReturnDashboardTotalsQuery } from "../../../newapi/dashboard/dashboardSlice";

const ReturnTotalsPanel = ({ byState = false }) => {
    const { t } = useTranslation();

    const returnsCard = { key: "returnCount", label: t("returns"), icon: <AssignmentReturnOutlinedIcon className="logo"/>, color: "blue", type: "number" };

    // A warehouse reads the work a period brought in; a relation reads how far its returns are.
    const cards = byState
        ? [
            returnsCard,
            { key: "expectedCount", label: t("expected_returns"), icon: <ScheduleOutlinedIcon className="logo"/>, color: "orange", type: "number" },
            { key: "processedCount", label: t("processed_returns"), icon: <TaskAltOutlinedIcon className="logo"/>, color: "purple", type: "number" },
            { key: "completedCount", label: t("completed_returns"), icon: <DoneAllOutlinedIcon className="logo"/>, color: "green", type: "number" },
        ]
        : [
            returnsCard,
            { key: "returnLineCount", label: t("return_lines"), icon: <FormatListBulletedIcon className="logo"/>, color: "purple", type: "number" },
            { key: "productCount", label: t("items"), icon: <Inventory2OutlinedIcon className="logo"/>, color: "orange", type: "number" },
            { key: "avgProductsPerReturn", label: t("avg_products_per_return"), icon: <FunctionsIcon className="logo"/>, color: "green", type: "number" },
        ];

    return (
        <ShTotalsPanel
            useTotals={useGetReturnDashboardTotalsQuery}
            useChart={useGetReturnDashboardChartQuery}
            chartSubtitles={{
                month: t("returns_per_month"),
                week: t("returns_per_week")
            }}
            // The bars are every return of the period; the states ride along in the tooltip.
            chartSeries={[
                { type: "number" },
                { type: "number", chartType: "hidden" },
                { type: "number", chartType: "hidden" },
                { type: "number", chartType: "hidden" },
            ]}
            cards={cards}
        />
    );
};

export default ReturnTotalsPanel;
